import { css } from 'emotion';
import React, { PureComponent } from 'react';
import { colors, fontSize, mq } from './../../../../css';
import Answer from './answer.svg';
import Reason from './reason.svg';
import Solution from './solution.svg';

export default class Flow extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <div className={s.wrapper}>
                <div className={s.flow}>
                    <div className={s.svgWrapper} data-text="Answer">
                        <Answer />
                    </div>
                    <div className={s.svgWrapper} data-text="Reason">
                        <Reason />
                    </div>
                    <div className={s.svgWrapper} data-text="Solution">
                        <Solution />
                    </div>
                </div>
            </div>
        );
    }
}

const s = {};

s.wrapper = css`
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    background: ${colors.white};
    ${mq({
        position: ['relative', 'relative', 'relative', 'absolute', 'relative'],
        paddingLeft: [20, 60, 60, 30, 0],
        paddingRight: [20, 60, 60, 100],

        paddingTop: [0, 0, 0, 80, 80, 120],
        paddingBottom: [60, 60, 80, 80, 80, 120],
    })};
    display: flex;
    flex-direction: column;
`;

s.quote = css`
    h4 {
        color: ${colors.blue};
        font-weight: 300;
        ${mq({
            fontSize: [
                fontSize(20),
                fontSize(20),
                fontSize(24),
                fontSize(24),
                fontSize(32),
            ],
            marginBottom: [40, 40, 40, 60],
            marginTop: [0, 0, 0, '2em', '1.5em'],
        })};
    }
`;

s.flow = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${mq({
        flexDirection: ['column', 'column', 'row', 'column', 'column', 'row'],
    })};
`;

s.svgWrapper = css`
    ${mq({
        width: ['50%', '50%', '25%'],
    })};
    margin-bottom: 30px;
    height: 100%;
    svg {
        width: 100%;
        height: 100%;
    }
    &::after {
        content: attr(data-text);
        display: block;
        text-align: center;
        width: 100%;
        font-size: ${fontSize(12)};
        font-weight: 500;
        color: ${colors.blue};
    }
`;



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/flow/flow.component.js